import {
  NOTIFICATION_LIST,
  UNVIEWED_NOTIFICATION_LIST,
  NOTIFICATION_DELETE,
  BELL_DATA,
  LOADING,
  NOT_FOUND,
} from "../action/type";

const initialState = {
  list: [{}],
  unviewed: [{}],
  deleteres: [{}],
  bell: [{}],
  loading:false,
  notFound:false
};
const notification = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return { ...state, list: action.payload ,loading:true,notFound:false };
    case NOT_FOUND:
      return { ...state, list: action.payload ,loading:false,notFound:true};
    case NOTIFICATION_LIST:
      return { ...state, list: action.payload ,loading:false,notFound:false};
    case BELL_DATA:
      return { ...state, bell: action.payload ,loading:false,notFound:false};
    case UNVIEWED_NOTIFICATION_LIST:
      return { ...state, unviewed: action.payload ,loading:false,notFound:false};
    case NOTIFICATION_DELETE:
      return { ...state, deleteres: action.payload ,loading:false,notFound:false};
    default:
      return state;
  }
};

export default notification;
